"use client";

import React from "react";
import BusinessSectionBlock from "./BusinessSectionBlock";
import cafetaria from "../../assets/cafetaria.png";

export default function BusinessSectionCafeteria() {
  return (
    <BusinessSectionBlock
      title="Start exploring Cafeteria"
      description="Still confused about choosing the food menu you want? Don't worry. We have several curated cafeterias and food options for you. You can view menu highlights, most-loved items, and how to reach each food stall."
      image={cafetaria}
      href="/f&b/cafetaria"
      reverse={false}
    />
  );
}